module.exports = __webpack_public_path__ + "static/img/5.7246a294.png";